class newsBlock {
    constructor() {

        let newsBlockEl = document.getElementById('news-block');
        if (!newsBlockEl) {
            // newsBlockEl.remove();
            return;
        }

        this.init();
    };
    async init() {

        let data = await this.fetchNews();

        let swiperHTML = '';
        data.forEach((item, index) => {

            let itemImageHTML = item.image ? `<div class="sg-news-block__item__image"><div class="field-image" lazy-style="background-image: url('${item.image}')" style="background-image: url('${slide.image}')">&nbsp;</div></div>` : ``;

            let dateString = '';
            if (item.date) {

                let date = new Date(item.date);
                let yr = date.getFullYear();
                let mnth = date.getMonth()+1;
                let dt = date.getDate();

                if (dt < 10) dt = '0' + dt;
                if (mnth < 10) mnth = '0' + mnth;
                dateString = `${dt}/${mnth}/${yr}`;
            }

            let itemCTAsHTML = '';
            item.cta.forEach(cta => {

                if (cta.label && cta.link) {

                    itemCTAsHTML += item.cta.length > 1 ?
                        `<a href="${cta.link}" target="_blank"> ${cta.label} </a>` :
                        `<a href="${cta.link}" target="_blank">
                            <span class="sg-news-block-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                                   <path d="M9.06442 9.84155L2.18462 17.1511C1.74702 17.6163 1.03752 17.6163 0.600023 17.1511C0.162623 16.6863 0.162623 15.9323 0.600023 15.4676L6.68762 8.99985L0.600223 2.53225C0.162823 2.06725 0.162823 1.31355 0.600223 0.84875C1.03772 0.38375 1.74722 0.38375 2.18482 0.84875L9.06462 8.15835C9.28332 8.39085 9.39262 8.69525 9.39262 8.99985C9.39262 9.30455 9.28312 9.60915 9.06442 9.84155Z" fill="#FF574C"></path>
                                </svg>
                            </span>
                            ${cta.label}
                        </a>`;
                }
            });


            let itemHTML = `
            <div class="sg-news-block__item swiper-slide has-image" role="group" aria-label="${index} / ${item.length}" style="width: 367px; margin-right: 30px;">
                ${itemImageHTML}
                <div class="sg-news-block__item__content">
                    <span class="date">${dateString}</span>
                    <div class="h4">${item.title ? item.title : ``}</div>
                    <div>${item.description ? item.description : ``}</div>
                </div>
                <div class="sg-news-block__item__links">${itemCTAsHTML}</div>
            </div>`;

            swiperHTML += itemHTML;
        });

        document.getElementById('news-block-wrapper').innerHTML = swiperHTML;

        new Swiper('.sg-news-block-slider', {
            slidesPerView: 1,
            spaceBetween: 30,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            }
        });
        document.querySelectorAll('a').forEach( aHref=> aHref.addEventListener("click", (event)=> {
          if (!event.target.classList.contains('toc-link') && !event.target.parentElement.classList.contains('toc-link')) {
            event.preventDefault();
            if ([...event.target.classList].includes('icon-arrow-next') && [...event.target.classList].includes('icon-for-mob')) {
                return false;
            }
            let link =  event.currentTarget.getAttribute("href");
            if (event.ctrlKey || event.metaKey) {
                window.open(link, '_blank');
            } else if (event.shiftKey) {
                window.open(link, '');
            } else {
                if (link != null) {
                    let checkHrefID = event.currentTarget.getAttribute("id");
                    let hasClass = event.target.classList.contains('no-popup');
                    if(checkHrefID === 'send_email_pdf' || checkHrefID === 'download_pdf_button' || hasClass || link.includes('.pdf')){
                        window.open(link, '_blank');
                    } else if(link.includes('http')) {
                      if (link.includes('www.facebook.com/pollenkontroll.no')){
                        openNoPopup (link);
                      }
                      else{
                        if (!link.includes('pollenkontroll.no') && !link.includes('shopify.com') && !link.includes('/apps/pages/')) openNoPopup (link);
                        else window.location.href= link;
                      }
                    }
                    else window.location.href= link;
                }
            }
          }
        }));
    };
    async fetchNews() {

        let response = await fetch(`https://alk-app.klarify.me/api/news`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${window.alkAppToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
        response = await response.json();

        return response.data;
    }
}


typeof newsBlock !== 'undefined' && new newsBlock();